// extracted by mini-css-extract-plugin
export default {"customWelcomePageMain":"CustomWelcomePage_customWelcomePageMain__iahsM"};